import EGDatePicker from "../DatePicker/EGDatePicker";
import Grid from '@mui/material/Grid2';
import { defaultSizes, defaultMargin, checkDatesOrder } from './data';
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import "./EGDateRange.scss"

const EGDateRange = ({
  startLabel = '',
  endLabel = '',
  startDate,
  endDate,
  minDate,
  maxDate,
  callback = (props = {}) => console.log(props),
  showError = false,
  errorMessage = '',
  sizes = defaultSizes,
  margin = defaultMargin,
}) => {
  const [startDay, setStartDay] = useState(null);
  const [endDay, setEndDay] = useState(null);
  const [minDay, setMinDay] = useState(null);
  const [maxDay, setMaxDay] = useState(null);
  const [error, setError] = useState('');

  // useEffect(() => {
  //   console.log('\n\n inner error')
  //   console.log(error)
  // }, [error]);

  useEffect(() => {
    if (startDay) {
      let adjustStartDay = startDay;
      if (adjustStartDay.isBefore(minDay)) {
        setStartDay(minDay);
      }
    }

    if (endDay) {
      let adjustEndDay = endDay;
      if (adjustEndDay.isBefore(minDay)) {
        setEndDay(minDay);
      }
    }
  }, [minDay]);

  useEffect(() => {
    if (endDay) {
      let adjustEndDay = endDay;
      if (adjustEndDay.isAfter(maxDay)) {
        setEndDay(maxDay);
      }
    }

    if (startDay) {
      let adjustStartDay = startDay;
      if (adjustStartDay.isAfter(maxDay)) {
        setStartDay(maxDay);
      }
    }
  }, [maxDay]);
  
  useEffect(() => {
    if (startDay && endDay && checkDatesOrder(startDay, endDay)) {
      setError('');
      callback({ startDay, endDay, minDay, maxDay, error: '' });
    } else {
      setError(errorMessage);
      callback({ startDay, endDay, minDay, maxDay, error: errorMessage });
    }
  }, [startDay, endDay]);
  
  useEffect(() => {
    setStartDay(dayjs(startDate, 'DD/MM/YYYY').isValid() ? dayjs(startDate, 'DD/MM/YYYY') : null);
    setEndDay(dayjs(endDate, 'DD/MM/YYYY').isValid() ? dayjs(endDate, 'DD/MM/YYYY') : null);
    setMinDay(dayjs(minDate, 'DD/MM/YYYY').isValid() ? dayjs(minDate, 'DD/MM/YYYY') : null);
    setMaxDay(dayjs(maxDate, 'DD/MM/YYYY').isValid() ? dayjs(maxDate, 'DD/MM/YYYY') : null);
  }, []);

  return (
    <>
      <Grid container spacing={2} sx={{ padding: '0', margin }}>
        <Grid
          size={sizes[0]}
        >
          <EGDatePicker
            label={startLabel}
            value={startDay}
            {...(minDay && { minDate: minDay })}
            maxDate={endDay}
            onChange={value => setStartDay(value)}
          />
        </Grid>
        <Grid
          size={sizes[1]}
        >
          <EGDatePicker
            label={endLabel}
            value={endDay}
            minDate={startDay}
            {...(maxDay && { maxDate: maxDay })}
            onChange={value => setEndDay(value)}
          />
        </Grid>
        {
          error && showError && (
            <>
              <Grid size={12} className="error">
                <span>{error}</span>
              </Grid>
            </>
          )
        }
      </Grid>
    </>
  );
};

export default EGDateRange;